import React, { useState } from 'react';
import classNames from 'classnames';
import { defineMessages, useIntl } from 'react-intl';

import AccessibilityMenu from 'Layout/NavBar/MegaMenu/AccessibilityMenu';
import FeaturedTab from 'Layout/NavBar/MegaMenu/FeaturedTab';
import ProductsMegaMenuTabLink from 'Layout/NavBar/MegaMenu/ProductsMegaMenuTabLink';
import ProductsMegaMenuTab from 'Layout/NavBar/MegaMenu/ProductsMegaMenuTab';

const messages = defineMessages({
  free_comic: {
    id: 'nav.fantasyverse-menu.freecomic',
    defaultMessage: 'Free Comic Book Day',
  },
  free_comic_text: {
    id: 'nav.fantasyverse-menu.freecomictext',
    defaultMessage: 'Celebrate Free Comic Book Day with exclusive deals and discover amazing comics for all ages.',
  },
  all_products: {
    id: 'nav.fantasyverse-menu.allproducts',
    defaultMessage: 'All Products',
  },
  all_products_text: {
    id: 'nav.fantasyverse-menu.allproductstext',
    defaultMessage: 'Browse our full collection of games, books, software, and more for every interest and passion.',
  },
});

function FantasyVerseMegaMenu({
  megaMenuTab = '',
  setMegaMenuTab = () => {},
  fantasyVerseComicBookDay,
  fantasyVerseTopSellers = [],
}) {
  const contentArray = [
    { key: 'fantasyVerseComicBookDay', hits: fantasyVerseComicBookDay },
    { key: 'fantasyVerseTopSellers', hits: fantasyVerseTopSellers },
  ];

  const defaultTabString = contentArray.find(({ hits }) => hits?.length > 0)?.key || '';

  const [tab, setTab] = useState(defaultTabString);

  const { formatMessage } = useIntl();

  const toggleTab = (newTab) => {
    if (tab !== newTab) {
      setTab(newTab);
    }
  };

  const hideDropDown = contentArray.every(({ hits }) => hits?.length === 0);

  if (hideDropDown) return false;

  // To avoid loading the large megamenu into the DOM, create a simple link structure for each tab below.
  const menuLinks = [
    { name: 'FantasyVerse', link: '/fantasyverse', products: fantasyVerseTopSellers, tabId: 'fantasyverse' },
  ];

  return (
    <div
      id="MegaMenu_fantasyVerse"
      className="container MegaMenuContainer MegaMenuContainer__fantasyVerse"
      onMouseEnter={() => setMegaMenuTab('fantasyVerse')}
      onMouseLeave={() => setMegaMenuTab('')}
    >
      <AccessibilityMenu menuLinks={menuLinks} from="fantasyVerse" />

      {megaMenuTab === 'fantasyVerse' &&
        <div className={classNames('MegaMenu', { 'MegaMenu--visible': megaMenuTab === 'fantasyVerse' })}>
          <div className="ProductsMegaMenu">
            <div className="ProductsMegaMenu__tabLinks">
              <ul className="ProductsMegaMenu__linksContainer" role="menu" id="MegaMenu_fantasyVerse">
                {fantasyVerseComicBookDay?.length > 0 &&
                  <ProductsMegaMenuTabLink name={formatMessage(messages.free_comic)} link="/fantasyverse" tab={tab} toggle={toggleTab} tabId="fantasyVerseComicBookDay" from="fantasyVerse" setMegaMenuTab={setMegaMenuTab} />
                }
                {fantasyVerseTopSellers?.length > 0
                  && fantasyVerseTopSellers?.slice(0, 14).map((product, index) => (
                    <ProductsMegaMenuTabLink
                      name={product.name || `Top Seller ${index + 1}`}
                      link={`/${product.type}/${product.slug}`}
                      tab={tab}
                      toggle={toggleTab}
                      tabId={`fantasyVerseProduct${index}`}
                      from="fantasyVerse"
                      setMegaMenuTab={setMegaMenuTab}
                      key={product.product_id}
                    />
                  ))}
                {fantasyVerseTopSellers?.length > 0 &&
                  <ProductsMegaMenuTabLink name={formatMessage(messages.all_products)} link="/fantasyverse" tab={tab} toggle={toggleTab} tabId="fantasyVerseTopSellers" from="fantasyVerse" setMegaMenuTab={setMegaMenuTab} />
                }
              </ul>
            </div>

            {fantasyVerseComicBookDay?.length > 0 &&
              <ProductsMegaMenuTab
                tab={tab}
                title={formatMessage(messages.free_comic)}
                hits={fantasyVerseComicBookDay}
                setMegaMenuTab={setMegaMenuTab}
                section={'fantasyVerseComicBookDay'}
                linkTo={'/fantasyverse'}
                subText={formatMessage(messages.free_comic_text)}
              />
            }

            {fantasyVerseTopSellers?.length > 0 &&
              <ProductsMegaMenuTab
                tab={tab}
                title={formatMessage(messages.all_products)}
                hits={fantasyVerseTopSellers}
                setMegaMenuTab={setMegaMenuTab}
                section={'fantasyVerseTopSellers'}
                linkTo={'/fantasyverse'}
                subText={formatMessage(messages.all_products_text)}
              />
            }

            {fantasyVerseTopSellers?.length > 0
              && fantasyVerseTopSellers?.slice(0, 14).map((product, index) => (
                <FeaturedTab
                  hit={product}
                  setMegaMenuTab={setMegaMenuTab}
                  tab={tab}
                  section={`fantasyVerseProduct${index}`}
                  key={product.product_id}
                />
              ))}
          </div>
        </div>
      }
    </div>
  );
}

export default FantasyVerseMegaMenu;
